<template>
    <div class="flex-con xs-pad-lr">
        <div
            class="tooltip is-tooltip-bottom"
            :data-tooltip="tooltip"
        >
            <i
                class="fa fa-truck icon"
                :class="statusClass"
            ></i>
        </div>
        <div
            v-if="includeText"
            class="status-text"
        >
            {{tooltip}}
        </div>
    </div>
</template>

<script>
import StatusUtil from '../../util/StatusUtil';
export default {
    name : "Shipment",
    props : {
        status : {
            type : Number,
            required : true,
        },
        includeText : {
            type : Boolean,
            required : false,
            default : false,
        },
    },
    computed : {
        statusClass () {
            return `status-color-${this.status}`;
        },
        tooltip () {
            if(this.status === StatusUtil.COMPLETION.FULLY.id){
                return 'Fully Shipped';
            }
            if(this.status === StatusUtil.COMPLETION.PARTIALLY.id){
                return 'Partially Shipped';
            }
            return 'Not Shipped';
        }
    }
}
</script>

<style scoped>

</style>
